/* TomSelect a richiesta: lo usa solo la ricerca avanzata
   (components/search/ricerca-avanzata.blade.php). Prima arrivavano su ogni
   pagina 47 KB di JS e 15 KB di CSS. Il CSS viaggia col chunk. */
let tomSelectPromise = null;

window.loadTomSelect = function () {
    if (!tomSelectPromise) {
        tomSelectPromise = Promise.all([
            import("tom-select"),
            import("tom-select/dist/css/tom-select.bootstrap5.min.css"),
        ]).then(([module]) => {
            const TomSelect = module.default ?? module;
            window.TomSelect = TomSelect;
            return TomSelect;
        });
    }
    return tomSelectPromise;
};
